// MIRRORED FILE — twin of src/utils/clientInvoiceStatus.js (line-for-line).
// CRA's ModuleScopePlugin forbids importing from the repo's src/, so the copy is the only
// way the page can offer the same moves the server accepts. Registered in `PAIRS` of
// `mirroredUtilParity.test.js`.
//
// Client-invoice status flow — the one owner (D96.1, owner 2026-10-06). Pure.
//   draft / saved / ready  move freely among themselves and on to sent;
//   sent -> partially_paid -> paid;
//   anything not cancelled may be cancelled (the server adds its own dispatched-goods
//   refusal, CLIENT_INVOICE_CANCEL_DISPATCHED); cancelled is final.
// Staying on the same status is not a move (allowed). A Save never lowers a status: the
// only way back from sent is a credit note.
const FREE = ['draft', 'saved', 'ready'];

export const CLIENT_INVOICE_STATUS_MOVES: Record<string, string[]> = {
  draft: [...FREE, 'sent', 'cancelled'],
  saved: [...FREE, 'sent', 'cancelled'],
  ready: [...FREE, 'sent', 'cancelled'],
  sent: ['partially_paid', 'paid', 'cancelled'],
  partially_paid: ['paid', 'cancelled'],
  paid: ['cancelled'],
  cancelled: [],
};

export function canMoveClientInvoiceStatus(from: unknown, to: unknown): boolean {
  if (typeof from !== 'string' || !Object.prototype.hasOwnProperty.call(CLIENT_INVOICE_STATUS_MOVES, from)) return false;
  return from === to || CLIENT_INVOICE_STATUS_MOVES[from].includes(to as string);
}
